import { createPortal } from 'react-dom';
import Loading from './Loading';
import '../components/styles/DeleteLogoConfirmPopup.css';

export function DeleteLogoConfirmPopup({ isOpen, logo, onConfirm, onCancel, isLoading }) {
  if (!isOpen) return null;
  if (isLoading) return <Loading />;

  const popupContent = (
    <div className="delete-logo-popup-overlay" onClick={onCancel}>
      <div className="delete-logo-popup-content" onClick={(e) => e.stopPropagation()}>
        <div className="delete-logo-popup-header">
          <h3>Confirm logo deletion</h3>
          <p>Do you want to delete this logo?</p>
        </div>
        <div className="delete-logo-popup-body">
          {logo && (
            <img
              src={logo.Thumbnail || logo.ThumbnailImg}
              alt="Logo to delete"
              className="delete-logo-preview"
            />
          )}
        </div>
        <div className="delete-logo-popup-footer">
          <button className="delete-logo-btn cancel-btn" onClick={onCancel} disabled={isLoading}>
            Cancel
          </button>
          <button className="delete-logo-btn confirm-btn" onClick={onConfirm} disabled={isLoading}>
            OK
          </button>
        </div>
      </div>
    </div>
  );

  // Render popup at root level using Portal to avoid stacking context issues
  return createPortal(popupContent, document.body);
}
